import { render, staticRenderFns } from "./use-case-form.vue?vue&type=template&id=550e0b54"
import script from "./use-case-form.vue?vue&type=script&lang=js"
export * from "./use-case-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports